<div class="layout-accordion" [style.--column-count]="columnCount()">
  <div class="layout-accordion__container">
    @for (item of data().accordionItems; track item.id) {
      <pai-accordion-item [title]="item.title ?? '-'">
        <div [paiLexicalRichText]="item.text"></div>
      </pai-accordion-item>
    }
  </div>
</div>
